import {
    createAbsoluteFromTokens,
    createRelativeFromTokens,
    ModelPath,
    PathToken,
    PathTokens,
    RelativeModelPath,
} from "./ModelPath";

export interface IterationEntry<TModelPath extends ModelPath> {
    iterable: TModelPath;
    suffix: RelativeModelPath;
}

export function buildIterationSequence<TModelPath extends ModelPath>(
    modelPath: TModelPath
): Array<IterationEntry<TModelPath>> {
    const result: Array<IterationEntry<TModelPath>> = [];
    const tokens = modelPath.getPathPartsAsArray();
    const createPathFunc = modelPath.isAbsolute() ? createAbsoluteFromTokens : createRelativeFromTokens;
    for (let i = 0; i < tokens.length; i++) {
        if (tokens[i] === PathTokens.each) {
            result.push({
                iterable: createPathFunc(tokens.slice(0, i)) as TModelPath,
                suffix: createRelativeFromTokens(tokens.slice(i + 1)),
            });
        }
    }
    return result;
}

export interface IterationEntryWithInstances<TModelPath extends ModelPath> {
    iterable: TModelPath;
    suffix: RelativeModelPath;
    instances: PathToken[];
}

export function buildIterationSequenceWithInstances<TModelPath extends ModelPath>(
    modelPath: TModelPath
): Array<IterationEntryWithInstances<TModelPath>> {
    const result: Array<IterationEntryWithInstances<TModelPath>> = [];
    const tokens = modelPath.getPathPartsAsArray();
    const createPathFunc = modelPath.isAbsolute() ? createAbsoluteFromTokens : createRelativeFromTokens;
    let currentInstances: PathToken[] = [];
    for (let i = 0; i < tokens.length; i++) {
        const token = tokens[i];
        if (token === PathTokens.each || PathTokens.isInstanceToken(token)) {
            currentInstances = currentInstances.concat(token);
            result.push({
                iterable: createPathFunc(
                    tokens.slice(0, i).map(x => (PathTokens.isInstanceToken(x) ? PathTokens.each : x))
                ) as TModelPath,
                suffix: createRelativeFromTokens(tokens.slice(i + 1)),
                instances: currentInstances,
            });
        }
    }
    return result;
}
